import type { ComponentPropsWithoutRef } from 'react'

const ListItemName = ({ className = '', ...props }: ComponentPropsWithoutRef<'dt'>) => <dt className={`text-sm ${className}`} {...props} />

export default ListItemName
